"use strict";
function __export(m) {
    for (var p in m) if (!exports.hasOwnProperty(p)) exports[p] = m[p];
}
Object.defineProperty(exports, "__esModule", { value: true });
__export(require("./BamHeaderReader"));
__export(require("./BamIndexReader"));
__export(require("./BamReader"));
//# sourceMappingURL=index.js.map